module.exports = {"id":null,"uraian":"","satuan":{"jumlah":0,"jenis":null},"kemasan":{"jumlah":0,"jenis":null},"hscode":null,"hsid":null,"fob":0,"insurance":0,"freight":0,"brutto":0,"netto":0,"cif":0,"nilai_pabean":0,"ppnbm_tarif":null,"kategori":[],"detailSekunders":{"data":[]},"kurs":{"data":{"id":null,"kode_valas":null,"jenis":null,"kurs_idr":0,"tanggal_awal":null,"tanggal_akhir":null,"created_at":null}},"refHs":{"data":null},"refKemasan":{"data":null},"refSatuan":{"data":null}}


//////////////////
// WEBPACK FOOTER
// ./src/defaults/defaultCdDetail.json
// module id = 6ibQ
// module chunks = 1